/**
 * Flujo compartido para que un auditor cambie de local (logout del local actual).
 * @param {Function} [closeUi] - Cierra menús / dropdown antes de los popups.
 */
export default {
    methods: {
        auditorRunChangeLocal(closeUi) {
            if (typeof closeUi === 'function') {
                closeUi()
            }
            let changesToSyncronize = false
            const self = this
            const employeeTranslations = {
                confirm: {
                    message:
                        self.$tc('config.changes_sync') +
                        ' ' +
                        self.$tc('config.changes_sync_logout', changesToSyncronize, { number: changesToSyncronize }) +
                        ' ' +
                        self.$tc('config.changes_sync_logout2', changesToSyncronize) +
                        ' ' +
                        self.$tc('config.changes_sync_logout3'),
                    textSave: self.$t('popup.confirm.stay_conected'),
                    textCancel: self.$t('popup.cancel.close_session')
                }
            }
            this.$store.dispatch('getCountSyncItems').then((count) => {
                changesToSyncronize = count
                if (count > 0) {
                    employeeTranslations.confirm.message =
                        changesToSyncronize > 0
                            ? employeeTranslations.confirm.message.replace('false', changesToSyncronize)
                            : employeeTranslations.confirm.message
                    self.$popup.confirm({
                        message: employeeTranslations.confirm.message,
                        textSave: employeeTranslations.confirm.textSave,
                        textCancel: employeeTranslations.confirm.textCancel,
                        callSave: function() {
                            self.$popup.close()
                        },
                        callCancel: function() {
                            self.$store.dispatch('login/logoutAuditorLocal').then(() => {
                                if (self.$route.name === 'Audit') {
                                    return
                                }
                                self.$router.push('/audit')
                            })
                        }
                    })
                } else {
                    self.$store.dispatch('login/logoutAuditorLocal').then(() => {
                        if (self.$route.name === 'Audit') {
                            return
                        }
                        self.$router.push('/audit')
                    })
                }
            })
        }
    }
}
